var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.8 33.1",
    style: {
      enableBackground: "new 0 0 26.8 33.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.8,33.1H4.1c-2.2,0-4.1-1.8-4.1-4.1v-25C0,1.8,1.8,0,4.1,0h18.7c2.2,0,4.1,1.8,4.1,4.1v25 C26.8,31.3,25,33.1,22.8,33.1z M4.1,1.5c-1.4,0-2.6,1.2-2.6,2.6v25c0,1.4,1.2,2.6,2.6,2.6h18.7c1.4,0,2.6-1.2,2.6-2.6v-25 c0-1.4-1.2-2.6-2.6-2.6H4.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "complete_16_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,28.1H4.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h17.9c0.4,0,0.7,0.3,0.7,0.7 C23.1,27.7,22.8,28.1,22.4,28.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,23.4H4.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h17.9c0.4,0,0.7,0.3,0.7,0.7 C23.1,23.1,22.8,23.4,22.4,23.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,18.8H4.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h17.9c0.4,0,0.7,0.3,0.7,0.7 C23.1,18.4,22.8,18.8,22.4,18.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,14.1h-5.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h5.1c0.4,0,0.7,0.3,0.7,0.7 C23.1,13.8,22.8,14.1,22.4,14.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,9.4h-6.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h6.7c0.4,0,0.7,0.3,0.7,0.7 C23.1,9.1,22.8,9.4,22.4,9.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,10C7.1,10,5.7,8.6,5.7,7s1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1S10.4,10,8.7,10z M8.7,5.4 C7.9,5.4,7.2,6.1,7.2,7c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C10.3,6.1,9.6,5.4,8.7,5.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,15.2C12.1,15.2,12.1,15.2,12.1,15.2H5.3c-0.4,0-0.7-0.3-0.7-0.7c0-2.7,1.8-5.6,4.1-5.6 c2.3,0,4.1,2.9,4.1,5.5c0,0.1,0,0.1,0,0.2C12.9,14.9,12.6,15.2,12.1,15.2z M6.1,13.7h5.2C11,12,9.9,10.3,8.7,10.3 C7.6,10.3,6.4,12,6.1,13.7z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.9fc6e62f401418a5d7d7dd93adc35d1b.svg";
export { ForwardRef as ReactComponent };